import { SPATIAL_TABS_MODAL_HIDDEN, VIEW_CENTER_SET, MAP_SCALE_SET, WINDOW_NOTIFICATION_SHOW } from './mutations.type';
import { SPATIAL_TABS_SHOW_MODAL, SPATIAL_TABS_POST_TAB, SPATIAL_TABS_FETCH, SPATIAL_TABS_DELETE, SPATIAL_TABS_PUT_TAB, SPATIAL_TABS_GOTO } from './actions.type';
import { Api as TabsApi } from '../api/api-zakladki';
import { transform } from "ol/proj";

export const state = {
  visible: false,
  tabs: [],
  loading: false
}

export const actions = {
  async [SPATIAL_TABS_SHOW_MODAL](context) {
    context.dispatch(SPATIAL_TABS_FETCH);
    state.visible = true;
  },
  async [SPATIAL_TABS_POST_TAB](context, name) {
    try {
      state.loading = true;
      const api = new TabsApi();
      const currentCenter = transform(context.getters.viewCenter, context.getters.coordinateSystem, "EPSG:2180");
      const response = await api.postZakladki({ nazwa: name, x: currentCenter[0], y: currentCenter[1], skala: context.getters.scale });
      state.tabs.push(response.body);
      context.commit(SPATIAL_TABS_MODAL_HIDDEN);

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: "success",
        title: "Sukces!",
        message: "Sukces. Dodawanie zakładki przestrzennej zakończone poprawnie.",
        duration: 5000
      });
    } catch (e) {
      
    } finally {
      state.loading = false;
    }
  },
  async [SPATIAL_TABS_FETCH]() {
    try {
      state.loading = true;
      const api = new TabsApi();
      const response = await api.getZakladki();
      state.tabs = response.body.zakladki;
    } catch (e) {
      
    } finally {
      state.loading = false;
    }
  },
  async [SPATIAL_TABS_DELETE](context, tab) {
    try {
      state.loading = true;
      const api = new TabsApi();
      await api.deleteZakladkiById({ id: tab.id });

      const indexOfTab = state.tabs.indexOf(tab);
      state.tabs.splice(indexOfTab, 1);

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: "success",
        title: "Sukces!",
        message: "Sukces. Usunięcie zakładki przestrzennej zakończone poprawnie.",
        duration: 5000
      });
    } catch (e) {

    } finally {
      state.loading = false;
    }
  },
  async [SPATIAL_TABS_PUT_TAB](context, data) {
    try {
      const api = new TabsApi();
      const response = await api.putZakladkiById({ id: data.tab.id, nazwa: data.name, x: data.tab.x, y: data.tab.y, skala: data.tab.skala });
      const indexOfTab = state.tabs.indexOf(data.tab);
      state.tabs.splice(indexOfTab, 1, response.body);
      context.commit(SPATIAL_TABS_MODAL_HIDDEN);

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: "success",
        title: "Sukces!",
        message: "Sukces. Zmiany zostały zapisane.",
        duration: 5000
      });
    } catch (error) {

    }
  },
  [SPATIAL_TABS_GOTO]({ commit, getters }, tab) {
    const center = transform([tab.x, tab.y], "EPSG:2180", getters.coordinateSystem);
    commit(VIEW_CENTER_SET, center);
    commit(MAP_SCALE_SET, tab.skala);
    commit(SPATIAL_TABS_MODAL_HIDDEN);
  }
}

export const mutations = {
  [SPATIAL_TABS_MODAL_HIDDEN]() {
    state.tabs = [];
    state.visible = false;
  }
}

export const getters = {
  spatialTabsModalVisible(state) {
    return state.visible;
  },
  spatialTabs(state) {
    return state.tabs;
  },
  spatialTabsLoading(state) {
    return state.loading;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}